import type { Component } from 'vue';
import Check from './Check.vue';
import CheckValue from './CheckValue.vue';
import SmallCheckItem from './SmallCheckItem.vue';

export default new Map<string, Component>([
  ['Check', Check],
  ['CheckValue', CheckValue],
  ['SmallCheckItem', SmallCheckItem],
]);



